


















import { defineComponent } from '@vue/composition-api'

/**
 * 共通 オーバーレイテンプレート
 */
export default defineComponent({
  name: 'CommonOverlaySection',
  props: {
    /**
     * 下部ボタンエリアの有無
     */
    hasButtons: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    emitClose(): void {
      /**
       * closeModal
       * 親コンポーネントへ閉じる処理を通知
       */
      this.$emit('close')
    },
  },
})
